import React, { useState, useMemo, useCallback, useEffect } from 'react';
import Chart from "react-apexcharts";

const RDSBarChart = ({ hours = [], counts = [] }) => {

    const shortenNumber = useCallback((value) => {
        if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1) + "B";
        if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
        if (value >= 1_000) return (value / 1_000).toFixed(1) + "k";
        return value;
    }, []);

    const options = useMemo(() => ({
        chart: {
            type: 'bar',
            height: 320,
            toolbar: { show: false }
        },
        dataLabels: {
            enabled: true,
            formatter: shortenNumber
        },
        plotOptions: {
            bar: { columnWidth: '45%' }
        },
        grid: {
            borderColor: '#e5e7eb',
            strokeDashArray: 4,
            yaxis: { lines: { show: true } },
            xaxis: { lines: { show: false } }
        },
        fill: { colors: ['#9367B4'] },
        yaxis: { show: false },
        xaxis: {
            categories: hours,
            axisTicks: { show: false },
            axisBorder: { show: false }
        },
        legend: { show: false },
        tooltip: {
            theme: "dark",
            y: { formatter: shortenNumber }
        }
    }), [hours, shortenNumber]);

    const series = useMemo(() => ([
        { data: counts }
    ]), [counts]);

    return (
        <Chart
            options={options}
            series={series}
            type="bar"
            height={320}
        />
    );
};


export default RDSBarChart